import React from 'react';
import { Calendar, Fuel, Settings, Zap } from 'lucide-react';
import type { VehicleDerivative } from '../../types/manualsearch.types';
import { Badge, Button, Card, CardTitle, Tooltip } from '@shared/components';

interface VehicleDerivativeCardProps {
    derivative: VehicleDerivative;
    onSelect?: (vehicle: VehicleDerivative) => void;
}

export const VehicleDerivativeCard: React.FC<VehicleDerivativeCardProps> = ({
    derivative,
    onSelect,
}) => {
    return (
        <Card className="flex flex-col">
            {/* Card Body */}
            <div className="p-4 mt-2 space-y-4">
                {/* Title and Badges */}
                <div>
                    <div className="flex flex-wrap gap-2 mb-4">
                        <Badge variant="secondary">{derivative.short_name}</Badge>
                    </div>
                    {derivative.make && derivative.model && (
                        <CardTitle>
                            {derivative.make.name} {derivative.model.name}
                        </CardTitle>
                    )}
                </div>

                {/* Vehicle Details Grid */}
                <div className="grid grid-cols-2 gap-2 text-sm">
                    <div className="flex items-center gap-2">
                        <Calendar className="w-4 h-4 text-mp-muted" />
                        <Tooltip
                            content={`Year of Manufacture: ${derivative.first_year_of_manufacture}`}
                        >
                            <span className="text-mp-foreground overflow-hidden text-ellipsis whitespace-nowrap">
                                {derivative.first_year_of_manufacture}
                            </span>
                        </Tooltip>
                    </div>

                    <div className="flex items-center gap-2">
                        <Zap className="w-4 h-4 text-mp-muted" />
                        <Tooltip content={`Engine Size: ${derivative.engine_size.description}`}>
                            <span className="text-mp-foreground overflow-hidden text-ellipsis whitespace-nowrap">
                                {derivative.engine_size.description}
                            </span>
                        </Tooltip>
                    </div>

                    <div className="flex items-center gap-2">
                        <Settings className="w-4 h-4 text-mp-muted" />
                        <Tooltip content={`Transmission: ${derivative.transmission.description}`}>
                            <span className="text-mp-foreground overflow-hidden text-ellipsis whitespace-nowrap">
                                {derivative.transmission.description}
                            </span>
                        </Tooltip>
                    </div>

                    <div className="flex items-center gap-2">
                        <Fuel className="w-4 h-4 text-mp-muted" />
                        <Tooltip content={`Fuel Type: ${derivative.fuel_type.description}`}>
                            <span className="text-mp-foreground overflow-hidden text-ellipsis whitespace-nowrap">
                                {derivative.fuel_type.description}
                            </span>
                        </Tooltip>
                    </div>
                </div>

                {/* Action */}
                {onSelect && (
                    <div className="flex justify-end items-end mt-auto">
                        <Button size={'xs'} onClick={() => onSelect(derivative)}>
                            Select Vehicle
                        </Button>
                    </div>
                )}
            </div>
        </Card>
    );
};
